module.exports = {
    "name": "With CORONA",
    "children": [
        {
            "name": "\u754c\u9762\u8f38\u9001\u5de5\u5b66",
            "children": [
                {
                    "name": "\u7a7a\u6c17\u306e\u30de\u30cd\u30b8\u30e1\u30f3\u30c8",
                    "children": [
                        {
                            "name": "\u7a7a\u6c17\u306e\u6d41\u308c\u30c8\u30e9\u30c3\u30ab\u30fc",
                            "value": 10,
                            "description": "\u7a7a\u6c17\u306e\u6d41\u308c\u3092\u30c8\u30e9\u30c3\u30af\u3057\u53ef\u8996\u5316\u3059\u308b\u30ab\u30e1\u30e9",
                            "image": "with_Air_Fluid_Tracker_trim.jpg",
                            "card_id": "W1",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#public",
                                        "#room"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u306b\u304a\u3044\u3067\u30a2\u30e9\u30fc\u30e0",
                            "value": 10,
                            "description": "\u5bc6\u306b\u306a\u3063\u3066\u3044\u308b\u5834\u6240\u3092\u611f\u77e5\u3057\u3001\u306b\u304a\u3044\u3067\u8b66\u5831\u3092\u51fa\u3059\u30c7\u30d0\u30a4\u30b9",
                            "image": "with_Alarm_with_Smell_trim.jpg",
                            "card_id": "W2",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#public",
                                        "#alarm"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u4f53\u5185\u30a8\u30a2\u30d5\u30a3\u30eb\u30bf\u30fc",
                            "value": 10,
                            "description": "\u80ba\u306b\u57cb\u3081\u8fbc\u3080\u4f53\u5185\u30a8\u30a2\u30d5\u30a3\u30eb\u30bf\u30fc",
                            "image": "with_Body_Air_Filter_trim.jpg",
                            "card_id": "W3",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#body",
                                        "#medical"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30a8\u30a2\u30ab\u30fc\u30c6\u30f3",
                            "value": 10,
                            "description": "\u516c\u5171\u4ea4\u901a\u6a5f\u95a2\u306b\u304a\u3044\u3066\u4eba\u3068\u306e\u9593\u306e\u7a7a\u6c17\u306e\u6d41\u308c\u3092\u30b3\u30f3\u30c8\u30ed\u30fc\u30eb\u3059\u308b\u4e8b\u304c\u3067\u304d\u308b",
                            "image": "with_Air_Curtain_trim.jpg",
                            "card_id": "W4",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#public",
                                        "#transportation"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u7a7a\u6c17\u304c\u7269\u8cea\u3068\u306a\u308b",
                    "children": [
                        {
                            "name": "\u30a8\u30a2\u30de\u30b9\u30af",
                            "value": 10,
                            "description": "\u7a7a\u6c17\u306e\u6d41\u308c\u3067\u3001\u30a6\u30a3\u30eb\u30b9\u3092\u5438\u3044\u8fbc\u3080\u306e\u3092\u9632\u3050\u30a8\u30a2\u30de\u30b9\u30af",
                            "image": "with_Air_Mask_trim.jpg",
                            "card_id": "W5",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#mask",
                                        "#wearable"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30a6\u30a7\u30a2\u30e9\u30d6\u30eb \u30a8\u30a2\u30ab\u30fc\u30c6\u30f3",
                            "value": 10,
                            "description": "\u7a7a\u6c17\u3067\u9632\u5fa1\u3059\u308b\u30a8\u30a2\u30ab\u30fc\u30c6\u30f3\u3002\u7279\u306b\u30de\u30b9\u30af\u3092\u3064\u3051\u306a\u3044\u5b50\u4f9b\u7528",
                            "image": "with_Wearable_Air_Curtain_trim.jpg",
                            "card_id": "W6",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#mask",
                                        "#child"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u6c34\u6d41\u306e\u30de\u30cd\u30fc\u30b8\u30e1\u30f3\u30c8",
                    "children": [
                        {
                            "name": "\u6c34\u6d41\u76e3\u8996\u9b5a\u578b\u30ed\u30dc\u30c3\u30c8",
                            "value": 10,
                            "description": "\u6c34\u6cf3\u30d7\u30fc\u30eb\u3084\u92ad\u6e6f\u3067\u6c34\u6d41\u3092\u76e3\u8996\u30fb\u7ba1\u7406\u3059\u308b\u3053\u3068\u304c\u3067\u304d\u308b\u9b5a\u578b\u30ed\u30dc\u30c3\u30c8",
                            "image": "with_Water_Fluid_Surveillance_Fish_Robot_trim.jpg",
                            "card_id": "W7",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#water",
                                        "#pool",
                                        "#public_bath"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u30de\u30a4\u30af\u30ed\u8981\u7d20\u69cb\u6210\u5b66",
            "children": [
                {
                    "name": "\u611f\u67d3\u691c\u67fb\u00d7\u4e8b\u67c4",
                    "children": [
                        {
                            "name": "\u611f\u67d3\u691c\u67fb\u517c\u30c1\u30b1\u30c3\u30c8",
                            "value": 10,
                            "description": "\u30e9\u30a4\u30d6\u30cf\u30a6\u30b9\u3084\u5927\u898f\u6a21\u306a\u96c6\u4f1a\u306e\u5165\u5834\u5238\u3068\u3057\u3066\u4f7f\u7528\u3067\u304d\u308b\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u30d1\u30c3\u30c1",
                            "image": "with_Infection_Test_Ticket_trim.jpg",
                            "card_id": "W8",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#Infection_test",
                                        "#ticket",
                                        "#gathering"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30d7\u30e9\u30a4\u30d9\u30fc\u30c8\u691c\u67fb\u30d1\u30c3\u30c1",
                            "value": 10,
                            "description": "\u30e2\u30d0\u30a4\u30eb\u3067\u500b\u4eba\u7684\u306b\u81ea\u5df1\u611f\u67d3\u30c6\u30b9\u30c8\u3092\u884c\u3046\u4e8b\u304c\u3067\u304d\u308b\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u30d1\u30c3\u30c1",
                            "image": "with_Private_Test_Patch_trim.jpg",
                            "card_id": "W9",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#Infection_test",
                                        "#privacy",
                                        "#mobile"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u5e03",
                            "value": 10,
                            "description": "\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u304c\u7e54\u308a\u8fbc\u307e\u308c\u305f\u751f\u5730\u3067\u4f5c\u3089\u308c\u305f\u611f\u67d3\u3092\u691c\u67fb\u3067\u304d\u308b\u670d",
                            "image": "with_Micro_needle_Fabric_trim.jpg",
                            "card_id": "W10",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#Infection_test",
                                        "#clothes",
                                        "#fabric"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30e2\u30fc\u30cb\u30f3\u30b0\u30eb\u30fc\u30c6\u30a3\u30f3\u30d1\u30c3\u30c1",
                            "value": 10,
                            "description": "\u6bce\u671d\u611f\u67d3\u691c\u67fb\u3092\u884c\u3046\u305f\u3081\u306b\u30d1\u30c3\u30b1\u30fc\u30b8\u5316\u3057\u305f\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u30d1\u30c3\u30c1",
                            "image": "with_Morning_Routine_Patch_trim.jpg",
                            "card_id": "W11",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#skin",
                                        "#habit",
                                        "#well_being"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u7dca\u6025\u30d1\u30c3\u30c1",
                            "value": 10,
                            "description": "\u611f\u67d3\u691c\u67fb\u3092\u76f4\u63a5\u3001\u7c21\u5358\u306b\u884c\u3048\u308b\u3088\u3046\u306b\u30d1\u30c3\u30b1\u30fc\u30b8\u5316\u3057\u305f\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u30d1\u30c3\u30c1",
                            "image": "with_Emergency_Patch_trim.jpg",
                            "card_id": "W12",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#skin",
                                        "#Infection_test",
                                        "#convenience_store"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u65b0\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u6d3b\u7528\u6cd5",
                    "children": [
                        {
                            "name": "\u5f3e\u4e38\u578b\u6295\u85ac\u30d1\u30c3\u30c1",
                            "value": 10,
                            "description": "\u5f3e\u4e38\u306e\u3088\u3046\u306b\u9060\u304f\u304b\u3089\u767a\u5c04\u3057\u3066\u85ac\u3092\u6295\u4e0e\u3067\u304d\u308b\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u30d1\u30c3\u30c1",
                            "image": "with_Bullet_Medicine_Patch_trim.jpg",
                            "card_id": "W13",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#infection",
                                        "#dosage",
                                        "#medicine"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30ef\u30af\u30c1\u30f3\u30d1\u30c3\u30c1\u30ab\u30ec\u30f3\u30c0\u30fc",
                            "value": 10,
                            "description": "\u4e88\u9632\u63a5\u7a2e\u7528\u30ad\u30c3\u30c8\u3068\u3057\u3066\u30ab\u30ec\u30f3\u30c0\u30fc\u3068\u7d71\u5408\u3055\u308c\u305f\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u30d1\u30c3\u30c1",
                            "image": "with_Vaccine_Patch_Calendar_trim.jpg",
                            "card_id": "W14",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#vaccine",
                                        "#immunization",
                                        "#habit"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "2WAY \u30d1\u30c3\u30c1",
                            "value": 10,
                            "description": "\u30ef\u30af\u30c1\u30f3\u306e\u6ce8\u5c04\u53ca\u3073\u7f8e\u5bb9\u30de\u30b9\u30af\u4e21\u65b9\u3067\u4f7f\u7528\u3067\u304d\u308b\u30de\u30a4\u30af\u30ed\u30cb\u30fc\u30c9\u30eb\u30d1\u30c3\u30c1",
                            "image": "with_Two_Way_Micro_needle_trim.jpg",
                            "card_id": "W15",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#Infection_test",
                                        "#cosmetic",
                                        "#fabric"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u533b\u7528\u30d0\u30a4\u30aa\u5de5\u5b66",
            "children": [
                {
                    "name": "\u691c\u67fb\u306e\u624b\u9593\u306e\u8efd\u6e1b",
                    "children": [
                        {
                            "name": "\u8840\u7ba1\u6e2c\u5b9a\u5305\u4e01",
                            "value": 10,
                            "description": "\u4f7f\u7528\u6642\u306b\u6bdb\u7d30\u8840\u7ba1\u306e\u72b6\u614b\u3092\u6e2c\u5b9a\u3057\u5065\u5eb7\u30c7\u30fc\u30bf\u3092\u4fdd\u7ba1\u3067\u304d\u308b\u5305\u4e01",
                            "image": "with_Capillary_Measuring_Knife_trim.jpg",
                            "card_id": "W16",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#daily_routine",
                                        "#health_care",
                                        "#data"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u8840\u7ba1\u6e2c\u5b9a\u9375",
                            "value": 10,
                            "description": "\u4f7f\u7528\u6642\u306b\u6bdb\u7d30\u8840\u7ba1\u306e\u72b6\u614b\u3092\u6e2c\u5b9a\u3057\u5065\u5eb7\u30c7\u30fc\u30bf\u3092\u4fdd\u7ba1\u3067\u304d\u308b\u9375",
                            "image": "with_Capillary_Measuring_Key_trim.jpg",
                            "card_id": "W17",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#daily_routine",
                                        "#health_care",
                                        "#data"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u81ea\u5b85\u30d8\u30eb\u30b9\u30b1\u30a2",
                    "children": [
                        {
                            "name": "\u5065\u5eb7\u30b3\u30f3\u30b7\u30a7\u30eb\u30b8\u30e5\u30ea\u30f3\u30b0",
                            "value": 10,
                            "description": "\u6bdb\u7d30\u8840\u7ba1\u30c7\u30fc\u30bf\u3092\u8a08\u6e2c\u3059\u308b\u6307\u8f2a\u578b\u306e\u30d8\u30eb\u30b9\u30b3\u30f3\u30b7\u30a7\u30eb\u30b8\u30e5",
                            "image": "with_Health_Concierge_Ring_trim.jpg",
                            "card_id": "W18",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#wearable",
                                        "#fashion"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u75c5\u6c17\u30bb\u30f3\u30b5\u30fc\u30ab\u30e1\u30e9",
                            "value": 10,
                            "description": "\u64ae\u5f71\u3055\u308c\u308b\u4eba\u306e\u75c5\u6c17\u3092\u691c\u77e5\u3059\u308b\u30ab\u30e1\u30e9",
                            "image": "with_Illness_Sensor_Camera_trim.jpg",
                            "card_id": "W23",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#medical",
                                        "#detection"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u4f1a\u8a71\u304c\u3044\u3089\u306a\u3044\u5065\u5eb7\u6e2c\u5b9a",
                    "children": [
                        {
                            "name": "\u4e73\u5150\u6bdb\u7d30\u8840\u7ba1\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0",
                            "value": 10,
                            "description": "\u6bdb\u7d30\u8840\u7ba1\u3067\u8d64\u3061\u3083\u3093\u306e\u5065\u5eb7\u72b6\u614b\u3092\u30e2\u30cb\u30bf\u30ea\u30f3\u30b0\u3067\u304d\u308b\u6e2c\u5b9a\u5668",
                            "image": "with_BabyCapillary_Monitoring_trim.jpg",
                            "card_id": "W19",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#remote",
                                        "#baby"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u8d85\u9ad8\u901f\u5149\u5b66",
            "children": [
                {
                    "name": "\u30a6\u30a3\u30eb\u30b9\u306e\u691c\u77e5",
                    "children": [
                        {
                            "name": "\u547c\u6c17\u611f\u67d3\u691c\u67fb",
                            "value": 10,
                            "description": "\u4eba\u3005\u306e\u547c\u5438\u3092\u30b9\u30ad\u30e3\u30f3\u3057\u3066\u691c\u67fb\u3059\u308b\u30a6\u30a4\u30eb\u30b9\u691c\u67fb\u6a5f",
                            "image": "with_Breath_infection_test_trim.jpg",
                            "card_id": "W20",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#Infection_test",
                                        "#breath"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30a6\u30a4\u30eb\u30b9\u30e2\u30cb\u30bf\u30fc",
                            "value": 10,
                            "description": "\u75c5\u9662\u7b49\u306e\u516c\u5171\u30b9\u30da\u30fc\u30b9\u306e\u63db\u6c17\u88c5\u7f6e\u306b\u53d6\u308a\u4ed8\u3051\u3089\u308c\u305f\u30a6\u30a4\u30eb\u30b9\u30e2\u30cb\u30bf\u30fc",
                            "image": "with_Virus_monitor_trim.jpg",
                            "card_id": "W21",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#data_visualisation",
                                        "#public"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u9060\u9694\u30a6\u30a3\u30eb\u30b9\u30c1\u30a7\u30c3\u30af",
                            "value": 10,
                            "description": "\u9060\u9694\u5730\u306e\u30a6\u30a3\u30eb\u30b9\u3092\u691c\u77e5\u3059\u308b\u671b\u9060\u93e1",
                            "image": "with_Remote_Virus_Check_trim.jpg",
                            "card_id": "W22",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#remote",
                                        "#detection"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u81ea\u5b85\u30d8\u30eb\u30b9\u30b1\u30a2",
                    "children": [
                        {
                            "name": "\u5065\u5eb7\u30b3\u30f3\u30b7\u30a7\u30eb\u30b8\u30e5\u30ea\u30f3\u30b0",
                            "value": 10,
                            "description": "\u6bdb\u7d30\u8840\u7ba1\u30c7\u30fc\u30bf\u3092\u8a08\u6e2c\u3059\u308b\u6307\u8f2a\u578b\u306e\u30d8\u30eb\u30b9\u30b3\u30f3\u30b7\u30a7\u30eb\u30b8\u30e5",
                            "image": "with_Health_Concierge_Ring_trim.jpg",
                            "card_id": "W18",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#wearable",
                                        "#fashion"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u75c5\u6c17\u30bb\u30f3\u30b5\u30fc\u30ab\u30e1\u30e9",
                            "value": 10,
                            "description": "\u64ae\u5f71\u3055\u308c\u308b\u4eba\u306e\u75c5\u6c17\u3092\u691c\u77e5\u3059\u308b\u30ab\u30e1\u30e9",
                            "image": "with_Illness_Sensor_Camera_trim.jpg",
                            "card_id": "W23",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#health_care",
                                        "#medical",
                                        "#detection"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u30a6\u30a3\u30eb\u30b9\u306e\u53ef\u8996\u5316",
                    "children": [
                        {
                            "name": "VR\u30a6\u30a3\u30eb\u30b9\u53ef\u8996\u5316",
                            "value": 10,
                            "description": "\u30a6\u30a3\u30eb\u30b9\u3092\u691c\u77e5\u3057\u53ef\u8996\u5316\u3059\u308bVR\u30b4\u30fc\u30b0\u30eb",
                            "image": "with_VR_virus visualization_trim.jpg",
                            "card_id": "W24",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#detection",
                                        "#data_visualisation",
                                        "#VR"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u30a6\u30a3\u30eb\u30b9\u306e\u53ef\u8074\u5316",
                    "children": [
                        {
                            "name": "\u30a6\u30a3\u30eb\u30b9\u306e\u97f3",
                            "value": 10,
                            "description": "\u30a6\u30a3\u30eb\u30b9\u3092\u691c\u77e5\u3057\u305f\u8d64\u5916\u7dda\u306e\u632f\u5e45\u3092\u97f3\u697d\u3068\u3057\u3066\u53ef\u8074\u5316\u3059\u308b",
                            "image": "with_Sound_of_Virus_trim.jpg",
                            "card_id": "W25",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#detection",
                                        "#alarm",
                                        "#auralization"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u540c\u4f4d\u4f53\u6c17\u8c61\u5b66",
            "children": [
                {
                    "name": "\u30b3\u30ed\u30ca\u306e\u5f71\u97ff\u306e\u8996\u899a\u5316",
                    "children": [
                        {
                            "name": "\u30b3\u30ed\u30ca\u30a4\u30f3\u30d1\u30af\u30c8\u30de\u30c3\u30d7",
                            "value": 10,
                            "description": "\u30b3\u30ed\u30ca\u306e\u826f\u3044/\u60aa\u3044\u5f71\u97ff\u3092\u4e16\u754c\u898f\u6a21\u3067\u8996\u899a\u5316\u3057\u305f\u30de\u30c3\u30d7",
                            "image": "with_COVID19_Impact_Map_trim.jpg",
                            "card_id": "W26",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#globe",
                                        "#data_visualisation",
                                        "#climate"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u7a7a\u4e2d\u30a6\u30a3\u30eb\u30b9\u691c\u77e5\u5668",
                            "value": 10,
                            "description": "\u96e8\u30fb\u98a8\u304b\u3089\u7a7a\u4e2d\u306e\u30a6\u30a3\u30eb\u30b9\u3092\u691c\u77e5\u3059\u308b\u691c\u77e5\u5668",
                            "image": "with_Virus_Air_borne_Detector_trim.jpg",
                            "card_id": "W27",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#detection",
                                        "#data_visualisation"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u6df7\u96d1\u306e\u8996\u899a\u5316",
                    "children": [
                        {
                            "name": "\u9759\u304b\u306a\u5e97\u30ac\u30a4\u30c9",
                            "value": 10,
                            "description": "\u5404\u5e97\u306e\u7a7a\u6c17\u306e\u6d41\u308c\u3092\u63a2\u77e5\u3057\u6df7\u96d1\u3057\u3066\u3044\u306a\u3044\u5e97\u3078\u6848\u5185\u3059\u308b\u30a2\u30d7\u30ea\u30b1\u30fc\u30b7\u30e7\u30f3",
                            "image": "with_Quiet_Shop_Finder_trim.jpg",
                            "card_id": "W28",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#data_visualisation",
                                        "#congestion"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u30d7\u30ed\u30b8\u30a7\u30af\u30c8\u30fb\u30de\u30cd\u30b8\u30e1\u30f3\u30c8\u5b66",
            "children": [
                {
                    "name": "\u6559\u80b2\u3092Re-code\u3059\u308b",
                    "children": [
                        {
                            "name": "\u5bfe\u8a71\u767a\u751f\u30b7\u30b9\u30c6\u30e0",
                            "value": 10,
                            "description": "\u30aa\u30f3\u30e9\u30a4\u30f3\u4e0a\u3067\u5b66\u751f\u9593\u306e\u5171\u901a\u306e\u95a2\u5fc3\u3092\u8b58\u5225\u3057\u5bfe\u8a71\u3092\u751f\u6210\u3059\u308b\u30b7\u30b9\u30c6\u30e0",
                            "image": "with_Dialog_Generating_System_trim.jpg",
                            "card_id": "W29",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#online",
                                        "#education",
                                        "#communication"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u89e6\u899a\u518d\u751f\u6a5f",
                            "value": 10,
                            "description": "\u540c\u671f\u632f\u52d5\u3057\u3066\u8077\u4eba\u306e\u4f53\u306e\u52d5\u304d\u3092\u7269\u7406\u7684/\u4eee\u60f3\u7684\u306b\u611f\u3058\u308b\u3053\u3068\u304c\u3067\u304d\u308b\u30da\u30f3",
                            "image": "with_Tactile_Sensation_Reproducer_trim.jpg",
                            "card_id": "W30",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#tactile",
                                        "#education",
                                        "#interaface"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u65b0\u3057\u3044\u63a5\u89e6\u306e\u611f\u899a",
                    "children": [
                        {
                            "name": "\u30bf\u30c3\u30c1\u30ec\u30b9\u89e6\u899a",
                            "value": 10,
                            "description": "\u89e6\u899a\u3092\u6a21\u5023\u3057\u3066\u7269\u7406\u7684\u306a\u63a5\u89e6\u3092\u56de\u907f\u3059\u308b\u30bf\u30c3\u30c1\u30b7\u30df\u30e5\u30ec\u30fc\u30bf",
                            "image": "with_Touchless_Tactile_Sensation_trim.jpg",
                            "card_id": "W31",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#touchless",
                                        "#interaface",
                                        "#tactile"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u65b0\u3057\u3044\u5bb6\u306e\u6a5f\u80fd",
                    "children": [
                        {
                            "name": "\u30bf\u30fc\u30b2\u30c3\u30c8\u30b5\u30a6\u30f3\u30c9",
                            "value": 10,
                            "description": "\u5bfe\u8c61\u8005\u3060\u3051\u304c\u805e\u304f\u3053\u3068\u304c\u3067\u304d\u308b\u97f3",
                            "image": "with_Targeted_Sound_trim.jpg",
                            "card_id": "W32",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#online",
                                        "#home",
                                        "#communication"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u90fd\u5e02\u30a8\u30cd\u30eb\u30ae\u30fc\u5de5\u5b66",
            "children": [
                {
                    "name": "\u7a4d\u6975\u7684\u306b\u826f\u3044\u7a7a\u6c17\u3092\u4f5c\u308b",
                    "children": [
                        {
                            "name": "\u30a6\u30a3\u30eb\u30b9\u30d5\u30a3\u30eb\u30bf\u30fc",
                            "value": 10,
                            "description": "\u30a6\u30a3\u30eb\u30b9\u3092\u9664\u53bb\u3059\u308b\u3053\u3068\u304c\u3067\u304d\u308b\u63db\u6c17\u30d5\u30a3\u30eb\u30bf\u30fc",
                            "image": "with_Virus_Filter_trim.jpg",
                            "card_id": "W33",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#cleaning",
                                        "#architecture"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30dd\u30fc\u30bf\u30d6\u30eb\u30a8\u30a2\u30af\u30ea\u30fc\u30ca\u30fc",
                            "value": 10,
                            "description": "\u6301\u3061\u904b\u3073\u53ef\u80fd\u3067\u53d6\u308a\u4ed8\u3051\u53ef\u80fd\u306a\u7a7a\u6c17\u6e05\u6d44\u6a5f",
                            "image": "with_Portable_Air_Cleaner_trim.jpg",
                            "card_id": "W34",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#cleaning",
                                        "#health"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u6bba\u30a6\u30a3\u30eb\u30b9\u30ac\u30e0",
                            "value": 10,
                            "description": "\u30b3\u30ed\u30ca\u30a6\u30a4\u30eb\u30b9\u3092\u6bba\u3057\u53e3\u306e\u4e2d\u306e\u74b0\u5883\u3092\u304d\u308c\u3044\u306b\u3059\u308b\u30ac\u30e0",
                            "image": "with_Virus_Killing_Gum_trim.jpg",
                            "card_id": "W35",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#cleaning",
                                        "#breath"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u9f3b\u30de\u30b9\u30af\u30fb\u53e3\u30de\u30b9\u30af",
                            "value": 10,
                            "description": "\u53e3\u3068\u9f3b\u306e\u4e2d\u306b\u3001\u5225\u3005\u306b\u88c5\u7740\u3059\u308b\u3053\u3068\u304c\u3067\u304d\u308b\u30de\u30b9\u30af",
                            "image": "with_Nose_Mask_Mouse_Mask_trim.jpg",
                            "card_id": "W49",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#wearable",
                                        "#mask",
                                        "#fashion"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u7a7a\u6c17\u306b\u5bfe\u3059\u308b\u65b0\u305f\u306a\u30cb\u30fc\u30ba",
                    "children": [
                        {
                            "name": "\u304d\u308c\u3044\u306a\u7a7a\u6c17\u306e\u30b5\u30fc\u30d3\u30b9",
                            "value": 10,
                            "description": "\u30b5\u30fc\u30d3\u30b9\u3068\u3057\u3066\u63d0\u4f9b\u3059\u308b\u304d\u308c\u3044\u306a\u7a7a\u6c17",
                            "image": "with_Clean Air Service_trim.jpg",
                            "card_id": "W36",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#architecture",
                                        "#well_being"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u65b0\u3057\u3044\u50cd\u304d\u65b9",
                    "children": [
                        {
                            "name": "\u9632\u97f3\u30de\u30b9\u30af",
                            "value": 10,
                            "description": "\u5916\u3078\u58f0\u304c\u805e\u3053\u3048\u306a\u3044\u30de\u30a4\u30af\u3092\u7d44\u307f\u8fbc\u3093\u3060\u9632\u97f3\u30de\u30b9\u30af",
                            "image": "with_Soundproof_Mask_trim.jpg",
                            "card_id": "W37",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#communication",
                                        "#mask",
                                        "#wearable"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30ea\u30e2\u30fc\u30c8\u30df\u30fc\u30c6\u30a3\u30f3\u30b0\u30b9\u30da\u30fc\u30b9",
                            "value": 10,
                            "description": "\u516c\u5171\u306e\u5834\u6240\u3067\u306e\u30ea\u30e2\u30fc\u30c8\u30df\u30fc\u30c6\u30a3\u30f3\u30b0\u7528\u30b9\u30da\u30fc\u30b9\u306e\u8a2d\u7f6e(\u30ab\u30d5\u30a7\u30fb\u516c\u5171\u65bd\u8a2d\u7b49)\u3002",
                            "image": "with_Remote_Meeting_Space_trim.jpg",
                            "card_id": "W38",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#remote",
                                        "#architecture",
                                        "#communication"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u65b0\u3057\u3044\u50cd\u304d\u65b9\u6307\u6a19",
                            "value": 10,
                            "description": "\u5728\u5b85\u52e4\u52d9\u7387\u3068\u7d4c\u6e08\u306e\u76f8\u95a2\u95a2\u4fc2\u3092\u8ffd\u8de1\u3057\u3066\u7b97\u51fa\u3057\u305f\u65b0\u3057\u3044\u50cd\u304d\u65b9\u6307\u6a19",
                            "image": "with_New_Work_Style_Index_trim.jpg",
                            "card_id": "W39",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#city",
                                        "#public",
                                        "#well_being"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u4eba\u9593\u90fd\u5e02\u60c5\u5831\u5b66",
            "children": [
                {
                    "name": "\u5b89\u5168\u6027\u306e\u53ef\u8996\u5316",
                    "children": [
                        {
                            "name": "\u611f\u67d3\u9632\u6b62\u30de\u30c3\u30d7",
                            "value": 10,
                            "description": "\u611f\u67d3\u3092\u56de\u907f\u3057\u3066\u76ee\u7684\u5730\u306b\u5230\u9054\u3059\u308b\u65b9\u6cd5\u3092\u793a\u3059\u5730\u56f3",
                            "image": "with_Infection_Prevention_Map_trim.jpg",
                            "card_id": "W40",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#public",
                                        "#infection",
                                        "#congestion"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u30a4\u30f3\u30bf\u30e9\u30af\u30c6\u30a3\u30d6\u8996\u899a\u77e5\u80fd",
            "children": [
                {
                    "name": "\u8996\u899a\u4f53\u9a13",
                    "children": [
                        {
                            "name": "VR\u30b3\u30ed\u30ca\u60a3\u8005\u4f53\u9a13",
                            "value": 10,
                            "description": "\u30b3\u30ed\u30ca\u60a3\u8005\u304c\u3069\u306e\u3088\u3046\u306b\u4ed6\u4eba\u304b\u3089\u5dee\u5225\u3055\u308c\u3066(\u898b\u3089\u308c\u3066)\u3044\u308b\u304b\u3092\u4f53\u9a13\u3059\u308bVR",
                            "image": "with_VR_Corona_Patient_Experience_trim.jpg",
                            "card_id": "W41",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#privacy",
                                        "#discrimination",
                                        "#communication"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u8996\u899a\u30e1\u30c7\u30a3\u30a2\u5de5\u5b66",
            "children": [
                {
                    "name": "\u30bf\u30c3\u30c1\u30ec\u30b9",
                    "children": [
                        {
                            "name": "\u30bf\u30c3\u30c1\u30ec\u30b9\u4ea4\u901a",
                            "value": 10,
                            "description": "\u63a5\u89e6\u3092\u6e1b\u3089\u3057\u611f\u67d3\u3092\u9632\u3050\u8a2d\u5099\u304c\u30d5\u30eb\u642d\u8f09\u3055\u308c\u3066\u3044\u308b\u4ea4\u901a\u6a5f\u95a2",
                            "image": "with_Touchless_Transportation_trim.jpg",
                            "card_id": "W42",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#office",
                                        "#touchless",
                                        "#infection"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u4e00\u4eba\u4e57\u308a\u5c0f\u578b\u8eca",
                            "value": 10,
                            "description": "\u30bf\u30c3\u30c1\u30ec\u30b9\u3067\u76ee\u7684\u5730\u306b\u884c\u304f\u3053\u3068\u304c\u3067\u304d\u308b\u4e00\u4eba\u4e57\u308a\u306e\u81ea\u5f8b\u904b\u8ee2\u8eca",
                            "image": "with_Singleseater_Compact_Car_trim.jpg",
                            "card_id": "W43",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#transportation",
                                        "#touchless",
                                        "#infection"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30de\u30a4\u30c9\u30ed\u30fc\u30f3",
                            "value": 10,
                            "description": "\u89e6\u3089\u305a\u306b\u30b8\u30a7\u30b9\u30c1\u30e3\u30fc\u3067\u64cd\u4f5c\u3067\u304d\u308b\u30d1\u30fc\u30bd\u30ca\u30eb\u30c9\u30ed\u30fc\u30f3",
                            "image": "with_My_Drone_trim.jpg",
                            "card_id": "W44",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#logistics",
                                        "#touchless",
                                        "#infection"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u624b\u8a71\u7ffb\u8a33\u6a5f",
                            "value": 10,
                            "description": "\u98db\u6cab\u611f\u67d3\u306e\u306a\u3044\u624b\u8a71\u3067\u306e\u4f1a\u8a71\u3092\u53ef\u80fd\u306b\u3059\u308b\u7ffb\u8a33\u6a5f",
                            "image": "with_Sign_Language_Translator_trim.jpg",
                            "card_id": "W45",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#communication",
                                        "#touchless",
                                        "#infection"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30bf\u30c3\u30c1\u30ec\u30b9\u4ee3\u66ff\u30b9\u30a4\u30c3\u30c1",
                            "value": 10,
                            "description": "\u5168\u3066\u306e\u30bf\u30c3\u30c1\u30ec\u30b9\u30c7\u30d0\u30a4\u30b9\u3092\u6ce8\u8996\u306b\u3088\u3063\u3066On/Off\u3067\u304d\u308b\u4ee3\u66ff\u30b9\u30a4\u30c3\u30c1",
                            "image": "with_Touchless_Alternate_Switch_trim.jpg",
                            "card_id": "W46",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#home",
                                        "#touchless",
                                        "#infection"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u5efa\u7bc9\u8a2d\u8a08\u5b66",
            "children": [
                {
                    "name": "\u67d4\u8edf\u306a\u90fd\u5e02",
                    "children": [
                        {
                            "name": "\u79fb\u52d5\u5f0f\u306e\u5bb6\u3067\u3067\u304d\u305f\u90fd\u5e02",
                            "value": 10,
                            "description": "\u72b6\u6cc1\u306b\u3088\u308a\u5bb6\u306e\u9593\u9694\u3092\u8abf\u7bc0\u3057\u4eba\u53e3\u5bc6\u5ea6\u3092\u5909\u3048\u308b\u3001\u79fb\u52d5\u5f0f\u306e\u5bb6\u3067\u3067\u304d\u305f\u90fd\u5e02",
                            "image": "with_Mobile_Home_City_trim.jpg",
                            "card_id": "W47",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#home",
                                        "#congestion",
                                        "#architecture"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u516c\u5171\u77ac\u9593\u79fb\u52d5\u30b9\u30dd\u30c3\u30c8",
                            "value": 10,
                            "description": "\u7269\u4f53\u306e\u5206\u5b50\u30b9\u30ad\u30e3\u30f3\u306b\u3088\u308b\u77ac\u9593\u79fb\u52d5\u304c\u3067\u304d\u308b\u30b9\u30dd\u30c3\u30c8\u304c\u914d\u7f6e\u3055\u308c\u3066\u3044\u308b\u8857",
                            "image": "with_Public_Teleportation_Spot_trim.jpg",
                            "card_id": "W48",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#communication",
                                        "#well_being",
                                        "#community"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "name": "\u751f\u7269\u7269\u7406\u5de5\u5b66",
            "children": [
                {
                    "name": "\u7a4d\u6975\u7684\u306b\u826f\u3044\u7a7a\u6c17\u3092\u4f5c\u308b",
                    "children": [
                        {
                            "name": "\u30a6\u30a3\u30eb\u30b9\u30d5\u30a3\u30eb\u30bf\u30fc",
                            "value": 10,
                            "description": "\u30a6\u30a3\u30eb\u30b9\u3092\u9664\u53bb\u3059\u308b\u3053\u3068\u304c\u3067\u304d\u308b\u63db\u6c17\u30d5\u30a3\u30eb\u30bf\u30fc",
                            "image": "with_Virus_Filter_trim.jpg",
                            "card_id": "W33",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#cleaning",
                                        "#architecture"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u30dd\u30fc\u30bf\u30d6\u30eb\u30a8\u30a2\u30af\u30ea\u30fc\u30ca\u30fc",
                            "value": 10,
                            "description": "\u6301\u3061\u904b\u3073\u53ef\u80fd\u3067\u53d6\u308a\u4ed8\u3051\u53ef\u80fd\u306a\u7a7a\u6c17\u6e05\u6d44\u6a5f",
                            "image": "with_Portable_Air_Cleaner_trim.jpg",
                            "card_id": "W34",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#cleaning",
                                        "#health"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u6bba\u30a6\u30a3\u30eb\u30b9\u30ac\u30e0",
                            "value": 10,
                            "description": "\u30b3\u30ed\u30ca\u30a6\u30a4\u30eb\u30b9\u3092\u6bba\u3057\u53e3\u306e\u4e2d\u306e\u74b0\u5883\u3092\u304d\u308c\u3044\u306b\u3059\u308b\u30ac\u30e0",
                            "image": "with_Virus_Killing_Gum_trim.jpg",
                            "card_id": "W35",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#air",
                                        "#cleaning",
                                        "#breath"
                                    ]
                                }
                            ]
                        },
                        {
                            "name": "\u9f3b\u30de\u30b9\u30af\u30fb\u53e3\u30de\u30b9\u30af",
                            "value": 10,
                            "description": "\u53e3\u3068\u9f3b\u306e\u4e2d\u306b\u3001\u5225\u3005\u306b\u88c5\u7740\u3059\u308b\u3053\u3068\u304c\u3067\u304d\u308b\u30de\u30b9\u30af",
                            "image": "with_Nose_Mask_Mouse_Mask_trim.jpg",
                            "card_id": "W49",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#wearable",
                                        "#mask",
                                        "#fashion"
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "name": "\u30b3\u30ed\u30ca\u5bfe\u7b56\u30d5\u30a1\u30c3\u30b7\u30e7\u30f3",
                    "children": [
                        {
                            "name": "\u9632\u30a6\u30a3\u30eb\u30b9\u30d5\u30a1\u30c3\u30b7\u30e7\u30f3",
                            "value": 10,
                            "description": "\u30a6\u30a4\u30eb\u30b9\u304c\u8868\u9762\u306b\u4ed8\u7740\u3057\u306a\u3044\u5e03\u3067\u4f5c\u3089\u308c\u305f\u670d",
                            "image": "with_Virus_proof_Fashion_trim.jpg",
                            "card_id": "W50",
                            "children": [
                                {
                                    "name": "",
                                    "tags": [
                                        "#wearable",
                                        "#fabric",
                                        "#fashion"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
};